import React from 'react';
import type { SharedBlockType } from '../types';
// eslint-disable-next-line camelcase
import type { ButtonLink as ButtonLinkType, Link_Type } from '../../graphql/generated/schema';
import { ButtonLink_ButtonType } from '../../graphql/generated/schema';
import { AppLink, Button } from '../../components';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';

export const ButtonLink: React.FC<SharedBlockType & ButtonLinkType> = ({
  buttonType,
  url,
  reference,
  isLargeButton,
  type,
  label,
  icon,
}) => (
  <AppLink
    className={constructClassName([
      styles.link,
      Boolean(isLargeButton) && styles.largeButtonLink,
    ])}
    link={{
      label,
      reference,
      url,
      // eslint-disable-next-line camelcase
      type: type as unknown as Link_Type,
    }}
  >
    <Button
      htmlElement="span"
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type={buttonType as any}
      className={constructClassName([
        styles.button,
        Boolean(isLargeButton) && styles.largeButton,
      ])}
      // eslint-disable-next-line camelcase
      icon={icon || buttonType === ButtonLink_ButtonType.Link ? 'chevronRightClassicLight' : undefined}
    >
      {label}
    </Button>
  </AppLink>

);
